import React, { FunctionComponent } from 'react';
import { FlashBox } from '../../atoms/flashBox';
import { SimpleHeader } from '../../organisms/simpleHeader';

type Props = {
  email: string;
  password: string;
  flash: boolean;
  flashType: string;
  flashMessage: string;
  isSubmitting: boolean;
  logoPc: string;
  logoSp: string;
  onChangeEmail: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onChangePassword: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  handleFlash: (flash: boolean, flashType: string, flashMessage: string) => void;
};

export const Presentation: FunctionComponent<Props> = ({
  email,
  password,
  flash,
  flashType,
  flashMessage,
  isSubmitting,
  logoPc,
  logoSp,
  onChangeEmail,
  onChangePassword,
  onSubmit,
  handleFlash,
}) => {
  return (
    <div className="wrap">
      <SimpleHeader logoPc={logoPc} logoSp={logoSp} />

      <div className="rtf-content w-100">
        <div className="rtf-company-register rtf-login">
          <div className="title">
            <p className="main">ログイン</p>
          </div>

          <FlashBox
            flash={flash}
            flashType={flashType}
            flashMessage={flashMessage}
            handleFlash={handleFlash}
          />

          <div className="form-wrapper">
            <form onSubmit={onSubmit}>
              <div className="form-group">
                <label htmlFor="inputEmail">メールアドレス</label>
                <input
                  type="text"
                  className="form-control"
                  id="inputEmail"
                  value={email}
                  onChange={onChangeEmail}
                />
              </div>
              <div className="form-group">
                <label htmlFor="inputPassword">パスワード</label>
                <input
                  type="password"
                  className="form-control"
                  id="inputPassword"
                  value={password}
                  onChange={onChangePassword}
                />
              </div>
              <button
                type="submit"
                className="button button-submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'ログイン中...' : 'ログイン'}
              </button>
              <div className="login-forget">
                <a href="/password_resets/new">パスワードを忘れた方はこちら</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};
